<section>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <div class="logo text-center">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(nov3)/img/logo-gif.gif"
            alt="logo"
            class="img-fluid"
          />
        </div>
      </div>
      <div class="col-lg-4"></div>
    </div>

    <div class="row justify-content-between align-items-center">
      <div class="col-lg-3 mt-5">
        <div class="left">
          <h1 class="ml7">
            <span class="text-wrapper">
              <span class="letters size2">Launching Soon!</span>
            </span>
          </h1>

          <h3 class="size1">
            ONPASSIVE A futuristic AI driven platform that gives you the chance
            to market anything online. Roll up your sleeves and start a fresh in
            your life. Work together with global economic leaders who will show
            you the path to success. This is a real opportunity promising
            cooperation and mutual benefit.
          </h3>

          <a
            href="/registration/user?reg={{ userId }}"
            class="hvr-bounce-to-right"
            id="regform1111"
            name="regform"
            target="_blank"
            rel="noopener"
          >
            <span class="founder-btn"> BECOME A FOUNDER NOW </span>
          </a>
        </div>
      </div>

      <div class="col-lg-5 mt-5 text-center">
        <div class="right-block">
          <div class="title">
            <h1 class="header">Revolutionary<br />Marketing System</h1>
          </div>
          <div class="video_box acc_panel anim_in">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
